module.exports = __webpack_public_path__ + "media/fyt_m25.f5db76e2.mp4";